import React, {useRef, useEffect} from 'react';
import {View, StyleSheet, ViewStyle} from 'react-native';
import moment from 'moment-timezone';

interface WebDatePickerProps {
  value: Date;
  onChange: (date: Date) => void;
  minDate?: Date;
  maxDate?: Date;
  style?: ViewStyle;
  placeholder?: string;
  containerStyle?: ViewStyle;
  colors?: {
    border: string;
    white: string;
    black: string;
    textSecondary: string;
  };
}

const WebDatePicker: React.FC<WebDatePickerProps> = ({
  value,
  onChange,
  minDate,
  maxDate,
  style,
  placeholder = 'YYYY-MM-DD',
  containerStyle,
  colors = {
    border: '#ccc',
    white: '#fff',
    black: '#000',
    textSecondary: '#666',
  },
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (inputRef.current && typeof window !== 'undefined') {
      const formattedDate = moment(value).format('YYYY-MM-DD');
      inputRef.current.value = formattedDate;

      if (minDate) {
        inputRef.current.min = moment(minDate).format('YYYY-MM-DD');
      }
      if (maxDate) {
        inputRef.current.max = moment(maxDate).format('YYYY-MM-DD');
      }
    }
  }, [value, minDate, maxDate]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = e.target.value;
    if (selectedValue) {
      const newDate = moment(selectedValue, 'YYYY-MM-DD', true).toDate();
      if (moment(newDate).isValid()) {
        onChange(newDate);
      }
    }
  };

  const containerStyles: any = {
    borderWidth: 1,
    borderColor: colors.border,
    borderRadius: 8,
    backgroundColor: colors.white,
    overflow: 'hidden',
    ...(containerStyle as any),
  };

  const inputStyles: any = {
    padding: 12,
    fontSize: 16,
    color: colors.black,
    minHeight: 44,
    fontFamily: 'system-ui',
    border: 'none',
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
    ...(style as any),
  };

  return (
    <View style={containerStyles}>
      <input
        ref={inputRef}
        type="date"
        onChange={handleChange}
        placeholder={placeholder}
        style={inputStyles}
      />
    </View>
  );
};

export default WebDatePicker;
